import { useMemo } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import Chat from "../components/Chat";
import { useUserProfile } from '../hooks/useUsers';

const ChatPage = () => {
  const { id }       = useParams();
  const navigate     = useNavigate();
  const location     = useLocation();
  const token        = useMemo(() => localStorage.getItem("token"), []);
  const { data, isLoading } = useUserProfile(token, id);

  const initialMessage = location.state?.initialMessage;

  if (isLoading) return null;
  if (!data) return null;

  const receiver = {
    _id:          id,
    username:     data.username,
    userPP:       data.userPP,
    socketId:     data.socketId,
    locationName: data.locationName,
    distance:     data.distance,
  };

  return (
    <Chat
      receiver={receiver}
      onClose={() => navigate(-1)}
      initialMessage={initialMessage}
    />
  );
};

export default ChatPage;